// extracted by mini-css-extract-plugin
export default {"chip":"StatusChip_chip__s2Pkr","ok":"StatusChip_ok__XJTbP","warn":"StatusChip_warn__N4vHZ","action":"StatusChip_action__LAJTA","neutral":"StatusChip_neutral__Qd3an"};